<template>
  <v-menu offset-y :close-on-content-click="true" nudge-bottom="8" content-class="lang-menu-content">
    <template v-slot:activator="{ attrs, on }">
      <v-btn v-bind="attrs" v-on="on" text class="lang-trigger">
        <img :src="getIcon" width="20" height="20" alt="" class="language-icon" />
        <span class="lang-code">{{ language.toUpperCase() }}</span>
      </v-btn>
    </template>

    <v-list class="lang-list" elevation="3">
      <v-list-item
        @click="() => select(l)"
        v-for="l in languages"
        :key="l.value"
        link
        class="lang-menu-item"
        :class="{ 'active-language': language === l.value }"
      >
        <v-list-item-avatar size="32" class="lang-avatar">
          <img :src="iconFor(l.value)" alt="" class="lang-flag" />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="lang-title">{{ l.text }}</v-list-item-title>
          <v-list-item-subtitle class="lang-subtitle">{{ l.value }}</v-list-item-subtitle>
        </v-list-item-content>
        <v-icon v-if="language === l.value" size="20" color="#16a085">mdi-check</v-icon>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import en from "../../assets/icons/united-kingdom.svg";
import it from "../../assets/icons/italy.svg";
import { ApiUtils } from "@/services/api/ApiUtils";

export default {
  name: "LanguagePicker",
  data() {
    return {
      language: "en",
      languages: [
        {
          value: "en",
          text: this.$t("common.english"),
        },
        {
          value: "it",
          text: this.$t("common.italian"),
        },
      ],
    };
  },
  mounted() {
    const initialLanguage = localStorage.getItem("lang");
    if (initialLanguage) {
      this.language = initialLanguage;
    }
  },
  props: {
    black: Boolean,
  },
  methods: {
    select(l) {
      this.language = l.value;
      localStorage.setItem("lang", l.value);
      ApiUtils.addDefaultHeader("X-User-Language", l.value);
      this.$root.$i18n.locale = l.value;
      location.reload();
    },
    iconFor(code) {
      switch (code) {
        case "en":
          return en;
        case "it":
          return it;
        default:
          return en;
      }
    },
  },
  computed: {
    getIcon() {
      switch (this.language) {
        case "en":
          return en;
        case "it":
          return it;
        default:
          throw new Error("Undefined language");
      }
    },
  },
};
</script>

<style scoped>
/* 2025 Modern Flat Design - Clean & Minimal */
.lang-trigger {
  height: 40px !important;
  min-width: auto !important;
  padding: 0 12px !important;
  margin: 0 !important;
  background-color: rgba(255, 255, 255, 0.08) !important;
  border-radius: 8px !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
}

@media (max-width: 600px) {
  .lang-trigger {
    height: 36px !important;
    padding: 0 6px !important;
    min-width: 38px !important;
    width: 38px !important;
  }
  .lang-code {
    display: none;
  }
  .language-icon {
    width: 18px !important;
    height: 18px !important;
  }
  .lang-trigger .v-icon {
    font-size: 16px !important;
  }
}

.lang-trigger:hover {
  background-color: rgba(255, 255, 255, 0.12) !important;
}

.language-icon {
  border-radius: 4px;
  display: block;
}

.lang-code {
  font-family: 'Inter', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
  color: #ffffff;
  font-size: 13px;
  font-weight: 600;
  margin: 0 8px;
  letter-spacing: 0.5px;
}

/* Dropdown menu styling */
.lang-menu-content {
  border-radius: 10px !important;
  overflow: hidden;
}

.lang-list {
  border-radius: 10px;
  padding: 6px;
  min-width: 200px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.lang-menu-item {
  padding: 10px 12px;
  min-height: 52px;
  margin-bottom: 2px;
  border-radius: 6px;
}

.lang-menu-item:last-child {
  margin-bottom: 0;
}

.lang-menu-item:hover {
  background-color: #f8f9fa;
}

.lang-menu-item.active-language {
  background-color: rgba(22, 160, 133, 0.08);
}

.lang-menu-item.active-language:hover {
  background-color: rgba(22, 160, 133, 0.12);
}

.lang-avatar {
  margin-right: 12px !important;
}

.lang-flag {
  border-radius: 4px;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.lang-title {
  font-family: 'Inter', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #2c3e50;
  line-height: 1.4;
}

.lang-subtitle {
  font-family: 'Inter', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 11px;
  color: #95a5a6;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  font-weight: 600;
  margin-top: 2px;
}
</style>
